import { render, staticRenderFns } from "./CreateDistrict.vue?vue&type=template&id=2036c5fc&"
import script from "./CreateDistrict.vue?vue&type=script&lang=js&"
export * from "./CreateDistrict.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports